var getVariableName = require('./getVariableName');
module.exports = function createPatternBuilder(dimension) {
  return pattern;
  function pattern(template, config) {
    var indent = config && config.indent || 0;
    var join = config && config.join !== undefined ? config.join : '\n';
    var indentString = Array(indent + 1).join(' ');
    var buffer = [];
    for (var i = 0; i < dimension; ++i) {
      var variableName = getVariableName(i);
      var prefix = i === 0 ? '' : indentString;
      buffer.push(prefix + template.replace(/{var}/g, variableName));
    }
    return buffer.join(join);
  }
};